/**
 * Locale + timezone constants.
 * Source: SYSTEM-PLAN §9 + caveats §10.
 */
export const BANGKOK_TZ = 'Asia/Bangkok';
export const DEFAULT_LANG = 'th';
export const FALLBACK_LANG = 'en';
